import { useWizard } from "react-use-wizard";
import React from "react";
import NavigateBack from "../../components/navigateBack";
import ConfirmTextInput from "../../components/confirmTextInput";
import stepMap from "./utils";

function TextInputStep({
  qKey,
  question,
  descriptions = [],
  labelText1,
  labelText2,
  subHeaderText,
  onSubmitHandler,
  state,
  prevWizardStep,
  isOpenedFromClinicQrCode = false,
}) {
  const { previousStep, nextStep, goToStep } = useWizard();

  const onNextFn = (data, noPatientID = false) => {
    // Set patient data based on whether noPatientID is true
    const patientData = noPatientID ? { PID: "" } : data;

    // Submit the patient data with the appropriate flag
    if (prevWizardStep) {
      onSubmitHandler(patientData, true);
    } else {
      onSubmitHandler(patientData);
    }

    // // Navigate to the next step based on conditions
    // if (isOpenedFromClinicQrCode || !noPatientID) {
    //   nextStep();
    // } else {
    //   goToStep(stepMap["PREF-TREATING-LOC"]);
    // }
    nextStep();
  };

  const goBack = () => {
    const ps = prevWizardStep();
    if (ps !== -1) {
      goToStep(ps);
    } else {
      previousStep();
    }
  };

  return (
    <>
      <NavigateBack onClickHandler={goBack} />
      <ConfirmTextInput
        question={question}
        descriptions={descriptions}
        labelText1={labelText1}
        labelText2={labelText2}
        subHeaderText={subHeaderText}
        inputResponseText={state || ""}
        qKey={qKey}
        onSubmitHandler={onNextFn}
      />
    </>
  );
}

export default TextInputStep;
